export const ticketErrors = {
  ...Object.fromEntries(
    ['404', '403'].map((k) => [
      k,
      {
        title: 'Ticket not found',
        message: `
          We seem to be having an issue loading this content,
          the ticket you are trying to access doesn't exist or is not available to you.
          If you believe this is a mistake, please contact your dedicated customer success manager at
          <a href="mailto:support@quointelligence.eu">support@quointelligence.eu</a> for
          further assistance.`,
      },
    ])
  ),
};
